module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (137).9c8c8189.jpg";